/* =============================================================================
   Night Operators ELF-FB20, static lander behaviour
   Vanilla JS. No dependencies. No framework.
   Scoped entirely inside #no-dfb31, touches nothing else on the page.
   Safe to load with <script defer> or at the end of the product template.
   ========================================================================== */
(function () {
  "use strict";

  var ROOT_ID = "no-dfb31";
  var CDN = "https://nightoperators-dfb-31.lovable.app";

  /* ---------------------------------------------------------------- pricing */
  var BASE_PRICE = 8299.95;
  var HELMET_PRICE = 149.95;

  var FOM_UPCHARGE = {
    "1400-1550": 0,
    "1600-1800": 700,
    "1800-1950": 1700,
    "2000-2100": 3400
  };



  var FOM_EXPLAINER = {
    "1400-1550": "Most start here. The thermal does the finding, the tubes give the scene.",
    "1600-1800": "1600-1800 FOM Gen 2+ tubes.",
    "1800-1950": "1800-1950 FOM Gen 2+ tubes.",
    "2000-2100": "2000-2100 FOM, sold out."
  };

  var OUT_OF_STOCK = { "2000-2100": true };

  /* ------------------------------------------------------- Shopify variants */
  var VARIANTS = {
    "1400-1550": "51821084279030",
    "1600-1800": "51821084311798",
    "1800-1950": "51821084344566",
    "2000-2100": "51821084377334",
    "BLK-M": "51760827728118",
    "BLK-L": "51760827760886"
  };

  /* ---------------------------------------------------------- helmet images */
  var HELMET_IMG = {
    BLK: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-blk.webp?v=1792014202",
    TAN: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-tan.webp?v=1792014222",
    RG: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-rg-nc1019.webp?v=1792014212"
  };
  var HELMET_IMG_2 = {
    BLK: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-detail.webp?v=1792014232",
    TAN: HELMET_IMG.TAN,
    RG: HELMET_IMG.RG
  };

  /* ------------------------------------------------------------------ state */
  var helmetStock = {};
  var state = { fom: "1400-1550", helmet: false, size: "M", color: "BLK" };

  /* ------------------------------------------------------------- utilities  */
  function fmt(n) {
    return (
      "$" +
      n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }
  function setClasses(el, on, onList, offList) {
    if (!el) return;
    var add = (on ? onList : offList).split(" ");
    var rm = (on ? offList : onList).split(" ");
    rm.forEach(function (c) {
      if (c) el.classList.remove(c);
    });
    add.forEach(function (c) {
      if (c) el.classList.add(c);
    });
  }

  var root = document.getElementById(ROOT_ID);
  if (!root) return;
  function $(sel) {
    return root.querySelector(sel);
  }
  function $$(sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  /* ---------------------------------------------------------------- classes */
  var PILL_ON = "border-accent bg-accent/15 text-accent";
  var PILL_OFF =
    "border-transparent bg-background/30 text-muted-foreground hover:border-accent/40 hover:text-foreground";
  var CHIP_ON = "border-accent text-accent bg-accent/10";
  var CHIP_OFF =
    "border-border text-muted-foreground hover:border-border-bright hover:text-foreground";

  /* ------------------------------------------------------------------ render */
  function kitPrice() {
    return BASE_PRICE + (FOM_UPCHARGE[state.fom] || 0);
  }
  function addOnsTotal() {
    return state.helmet ? HELMET_PRICE : 0;
  }
  function grandTotal() {
    return kitPrice() + addOnsTotal();
  }

  function render() {
    if (helmetStock[state.color + "-" + state.size] !== true) state.helmet = false;
    /* FOM pills */
    $$("[data-np-fom]").forEach(function (btn) {
      var f = btn.getAttribute("data-np-fom");
      var sold = !!OUT_OF_STOCK[f];
      btn.disabled = sold;
      btn.setAttribute("aria-disabled", String(sold));
      btn.classList.toggle("line-through", sold);
      if (sold) { btn.setAttribute("aria-pressed","false"); return; }
      var on = f === state.fom;
      setClasses(btn, on, PILL_ON, PILL_OFF);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var up = btn.querySelector("span");
      if (up) setClasses(up, on, "text-accent/70", "text-muted-foreground/70");
    });

    var expl = $("[data-np-fom-explainer]");
    if (expl) expl.textContent = FOM_EXPLAINER[state.fom];

    /* prices */
    var tot = $("[data-np-total]");
    if (tot) tot.textContent = fmt(grandTotal());

    /* add-on subtotal chip */
    var sub = $("[data-np-addon-total]");
    if (sub) {
      if (addOnsTotal() > 0) {
        sub.style.display = "";
        sub.textContent = "+" + fmt(addOnsTotal());
      } else {
        sub.style.display = "none";
      }
    }

    /* CTA */
    var cta = $("[data-np-cta]");
    if (cta) {
      cta.textContent =
        (addOnsTotal() > 0
          ? "Get The ELF-FB20 + Add-ons, " + fmt(grandTotal())
          : "Get The ELF-FB20, " + fmt(kitPrice())) + " →";
    }

    /* helmet switch */
    var sw = $("[data-np-toggle]");
    if (sw) {
      sw.setAttribute("aria-checked", state.helmet ? "true" : "false");
      setClasses(
        sw,
        state.helmet,
        "border-accent bg-accent/30",
        "border-border-bright bg-background/60 hover:border-accent"
      );
      var knob = sw.querySelector("[data-np-knob]");
      setClasses(
        knob,
        state.helmet,
        "bg-accent",
        "left-[3px] bg-muted-foreground"
      );
    }
    setClasses($("[data-np-row-title]"), state.helmet, "text-accent", "text-foreground");
    setClasses($("[data-np-row-price]"), state.helmet, "text-accent", "text-muted-foreground");

    var knob = $("[data-np-knob]");
    if (knob) knob.style.left = state.helmet ? "calc(100% - 18px)" : "3px";
    var unavailable = !!OUT_OF_STOCK[state.fom];
    $$("[data-np-cta],[data-np-atc-overlay]").forEach(function(b) { b.disabled = unavailable; b.setAttribute("aria-disabled",String(unavailable)); });
    var helmetUnavailable = helmetStock[state.color + "-" + state.size] !== true;
    [$("[data-np-toggle]"),$("[data-np-dialog-cta]")].forEach(function(b) { if(b)b.disabled=helmetUnavailable; });
    var row = $("[data-np-row-title]");
    if (row) row.textContent = helmetUnavailable ? "Helmet stock unavailable" : "GEN II FAST SF VENTED HELMET";
    var opener = $("[data-np-open-dialog]");
    if (opener) { opener.title = helmetUnavailable ? "Helmet stock unavailable" : ""; opener.setAttribute("data-unavailable", String(helmetUnavailable)); }
    var hkeys = Object.keys(helmetStock);
    if (opener) opener.style.display = (hkeys.length && !hkeys.some(function (k) { return helmetStock[k] === true; })) ? "none" : "";
    /* size / colour chips (row + dialog) */
    $$("[data-np-size]").forEach(function (b) {
      b.disabled = helmetStock[state.color + "-" + b.getAttribute("data-np-size")] !== true;
      b.style.display = (!VARIANTS[state.color + "-" + b.getAttribute("data-np-size")] || helmetStock[state.color + "-" + b.getAttribute("data-np-size")] === false) ? "none" : "";
      setClasses(b, b.getAttribute("data-np-size") === state.size, CHIP_ON, CHIP_OFF);
    });
    $$("[data-np-color]").forEach(function (b) {
      b.disabled = helmetStock[b.getAttribute("data-np-color") + "-" + state.size] !== true;
      b.style.display = ["M", "L"].some(function (z) { var k = b.getAttribute("data-np-color") + "-" + z; return VARIANTS[k] && helmetStock[k] !== false; }) ? "" : "none";
      setClasses(b, b.getAttribute("data-np-color") === state.color, CHIP_ON, CHIP_OFF);
    });

    /* images */
    var thumb = $("[data-np-thumb]");
    if (thumb) thumb.src = HELMET_IMG[state.color];
    var d0 = $('[data-np-dialog-img="0"]');
    if (d0) d0.src = HELMET_IMG[state.color];
    var d1 = $('[data-np-dialog-img="1"]');
    if (d1) d1.src = HELMET_IMG_2[state.color];

    /* dialog CTA */
    var dcta = $("[data-np-dialog-cta]");
    if (dcta) {
      dcta.textContent = state.helmet
        ? "✓ ADDED, $149.95"
        : "+ ADD HELMET, $149.95";
      setClasses(
        dcta,
        state.helmet,
        "bg-accent text-accent-foreground",
        "text-accent hover:bg-accent/10"
      );
    }
  }

  /* ------------------------------------------------------------- interaction */
  $$("[data-np-fom]").forEach(function (btn) {
    var f = btn.getAttribute("data-np-fom");
    if (OUT_OF_STOCK[f]) return;
    btn.addEventListener("click", function () {
      if (OUT_OF_STOCK[f]) return;
      state.fom = f;
      render();
    });
  });

  function toggleHelmet() {
    if (!state.helmet && helmetStock[state.color + "-" + state.size] !== true) return;
    state.helmet = !state.helmet;
    render();
  }
  var sw = $("[data-np-toggle]");
  if (sw)
    sw.addEventListener("click", function (e) {
      e.stopPropagation();
      toggleHelmet();
    });
  var dcta = $("[data-np-dialog-cta]");
  if (dcta) dcta.addEventListener("click", toggleHelmet);

  $$("[data-np-size]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.stopPropagation();
      var sz = b.getAttribute("data-np-size");
      if (helmetStock[state.color + "-" + sz] !== true) return;
      state.size = sz;
      render();
    });
  });
  $$("[data-np-color]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.stopPropagation();
      var col = b.getAttribute("data-np-color");
      if (helmetStock[col + "-" + state.size] !== true) return;
      state.color = col;
      render();
    });
  });

  /* ------------------------------------------------------------- add-on modal */
  var modal = $("[data-np-modal]");
  var lastFocus = null;
  if (modal) modal.addEventListener("click", function(e) { if(e.target === modal)closeModal(); });
  if (modal) modal.addEventListener("cancel", function(e) { e.preventDefault();closeModal(); });

  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.showModal();
    document.documentElement.style.overflow = "hidden";
    var close = $("[data-np-close]");
    if (close) close.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.close();
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var opener = $("[data-np-open-dialog]");
  if (opener) {
    opener.addEventListener("click", function (e) {
      if (e.target.closest("[data-np-toggle],[data-np-size],[data-np-color]")) return;
      openModal();
    });
    opener.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openModal();
      }
    });
  }
  var closeBtn = $("[data-np-close]");
  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  var overlay = $("[data-np-overlay]");
  if (overlay) overlay.addEventListener("click", closeModal);

  /* ----------------------------------------------------------- image lightbox */
  var lightbox = null;
  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement("dialog");
      lightbox.setAttribute("data-np-lightbox", "1");
      lightbox.style.cssText =
        "position:absolute;inset:auto;margin:auto;z-index:2147482500;background:hsl(var(--background));color:hsl(var(--foreground));" +
        "display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out";
      lightbox.innerHTML = '<img alt="" style="max-width:92vw;max-height:88vh;object-fit:contain">';
      lightbox.addEventListener("click", closeLightbox);
      root.appendChild(lightbox);
    }
    var img = lightbox.querySelector("img");
    img.src = src;
    img.alt = alt || "";
    lightbox.showModal();
    document.documentElement.style.overflow = "hidden";
  }
  function closeLightbox() {
    if (lightbox) lightbox.close();
    document.documentElement.style.overflow = "";
  }
  $$("[data-np-zoom]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      openLightbox(el.getAttribute("data-np-zoom"), el.getAttribute("data-np-zoom-alt"));
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (lightbox && lightbox.open) return closeLightbox();
    if (modal && modal.open) closeModal();
  });

  /* ------------------------------------------- expand / collapse comparison */
  var expBtn = $("[data-np-expand-btn]");
  var expPanel = $("[data-np-expand-panel]");
  var expFade = $("[data-np-expand-fade]");
  if (expBtn && expPanel) {
    expBtn.addEventListener("click", function () {
      var open = expPanel.classList.contains("max-h-[6000px]");
      expPanel.classList.toggle("max-h-[6000px]", !open);
      expPanel.classList.toggle("max-h-[180px]", open);
      expPanel.setAttribute("aria-hidden", open ? "true" : "false");
      expBtn.setAttribute("aria-expanded", open ? "false" : "true");
      if (expFade) expFade.style.display = open ? "" : "none";
      var chevron = expBtn.querySelector("svg");
      if (chevron) chevron.classList.toggle("rotate-180", !open);
      var label = expBtn.firstChild;
      if (label && label.nodeType === 3)
        label.nodeValue = open ? "Expand Comparison" : "Collapse";
    });
  }

  /* ------------------------------------------------- kit image ADD TO CART tap */

  var kitBtn = $("[data-np-kit-img]");
  var atc = $("[data-np-atc-overlay]");
  var atcTimer = null;
  if (kitBtn && atc) {
    kitBtn.addEventListener("click", function () {
      atc.classList.remove("opacity-0", "pointer-events-none");
      atc.classList.add("opacity-100", "pointer-events-auto");
      atc.setAttribute("aria-hidden", "false");
      atc.setAttribute("tabindex", "0");
      if (atcTimer) clearTimeout(atcTimer);
      atcTimer = setTimeout(function () {
        atc.classList.add("opacity-0", "pointer-events-none");
        atc.classList.remove("opacity-100", "pointer-events-auto");
        atc.setAttribute("aria-hidden", "true");
        atc.setAttribute("tabindex", "-1");
      }, 3000);
    });
    atc.addEventListener("click", function (e) {
      e.stopPropagation();
      if (atc.classList.contains("opacity-100")) addToCart();
    });
  }

  /* --------------------------------------------------------------- FAQ toggle */
  var faqBtns = $$("[data-np-faq-btn]");
  faqBtns.forEach(function (btn, i) {
    btn.addEventListener("click", function () {
      var panel = btn.parentNode.querySelector("[data-np-faq-panel]");
      var isOpen = panel.classList.contains("max-h-[1400px]");
      faqBtns.forEach(function (other) {
        var p = other.parentNode.querySelector("[data-np-faq-panel]");
        var plus = other.querySelector("[data-np-faq-plus]");
        other.setAttribute("aria-expanded","false");
        p.setAttribute("aria-hidden","true");
        p.classList.remove("max-h-[1400px]", "pb-7");
        p.classList.add("max-h-0");
        if (plus) plus.classList.remove("rotate-45");
      });
      if (!isOpen) {
        btn.setAttribute("aria-expanded","true");
        panel.setAttribute("aria-hidden","false");
        panel.classList.remove("max-h-0");
        panel.classList.add("max-h-[1400px]", "pb-7");
        var plus = btn.querySelector("[data-np-faq-plus]");
        if (plus) plus.classList.add("rotate-45");
      }
    });
  });

  /* --------------------------------------------------------------- ADD TO CART */
  var cartBusy = false;
  function addToCart() {
    if (cartBusy || OUT_OF_STOCK[state.fom]) return;
    if (state.helmet && helmetStock[state.color + "-" + state.size] !== true) {
      alert("The selected helmet is unavailable. Please choose another size or color."); return;
    }
    cartBusy = true;
    var items = [
      {
        id: VARIANTS[state.fom],
        quantity: 1,
        properties: { FOM: state.fom }
      }
    ];
    if (state.helmet) {
      items.push({
        id: VARIANTS[state.color + "-" + state.size],
        quantity: 1,
        properties: { Color: state.color, Size: state.size }
      });
    }

    var busy = $$("[data-np-cta],[data-np-atc-overlay]");
    busy.forEach(function (b) {
      b.setAttribute("aria-busy", "true");
      b.style.opacity = "0.7";
    });

    fetch("/cart/add.js", {
      credentials: "same-origin",
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
        if (window.noCartDrawerOpen) { return res.json().then(function (j) { window.noCartDrawerOpen(j); }, function () { window.noCartDrawerOpen(); }); }
        window.location.href = "/cart";
      })
      .catch(function (err) {
        /* eslint-disable-next-line no-console */
        console.error("[dfb31-lander] add to cart failed", err);
        alert("Sorry, we could not add the items to your cart. Please try again.");
      })
      .then(function () {
        cartBusy = false;
        busy.forEach(function (b) {
          b.removeAttribute("aria-busy");
          b.style.opacity = "";
        });
      });
  }

  var cta = $("[data-np-cta]");
  if (cta) cta.addEventListener("click", addToCart);

  /* --------------------------------------------------------- lazy media kick */
  $$("video").forEach(function (v) {
    v.muted = true; v.playsInline = true; /* NO-VIDEO-INLINE-1014 */
    if (v.autoplay || v.hasAttribute("data-np-autoplay")) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  });

  function updateProductStock(product) {
    if (!product || !Array.isArray(product.variants)) return;
    Object.keys(FOM_UPCHARGE).forEach(function(f) {
      var v = product.variants.find(function(v) { return String(v.id) === VARIANTS[f]; });
      if(v && typeof v.available === "boolean") OUT_OF_STOCK[f] = !v.available;
    });
    OUT_OF_STOCK["2000-2100"] = true;
    if(OUT_OF_STOCK[state.fom]) {
      var available = Object.keys(FOM_UPCHARGE).find(function(f) { return !OUT_OF_STOCK[f]; });
      if(available)state.fom=available;
    }
    render();
  }
  /* round 4 (14 Oct 2026, Bon): we only sell the VENTED helmet now. COLOR-SIZE to variant id, read from the live
     helmet product, VENTED shell only, so a new vented colour or size shows up here by itself once it is in stock. */
  function noVented(p) {
    var out = {}; if (!p || !p.variants) return out;
    var names = (p.options || []).map(function (o) { return String(o && o.name != null ? o.name : o).toUpperCase(); });
    var iS = names.indexOf("SIZE"), iC = names.indexOf("COLOR"), iH = names.indexOf("SHELL");
    if (iS < 0 || iC < 0 || iH < 0) return out;
    var SZ = { MEDIUM: "M", LARGE: "L" }, CO = { BLACK: "BLK", "RANGER GREEN": "RG", TAN: "TAN" };
    p.variants.forEach(function (v) {
      var o = v.options || [v.option1, v.option2, v.option3];
      if (String(o[iH]).toUpperCase() !== "VENTED") return;
      var z = SZ[String(o[iS]).toUpperCase()], c = CO[String(o[iC]).toUpperCase()];
      if (z && c) out[c + "-" + z] = String(v.id);
    });
    return out;
  }
  function updateHelmetStock(product) {
    helmetStock = {};
    if(!product || !Array.isArray(product.variants)) { state.helmet = false; render(); return; }
    var vm = noVented(product); Object.keys(vm).forEach(function (k) { VARIANTS[k] = vm[k]; });
    Object.keys(VARIANTS).filter(function(k) { return /^(BLK|TAN|RG)-[ML]$/.test(k); }).forEach(function(k) {
      var v=product.variants.find(function(v) { return String(v.id)===VARIANTS[k]; });
      helmetStock[k] = !!v && v.available === true;
    });
    if(helmetStock[state.color+"-"+state.size] !== true) {
      var first=Object.keys(helmetStock).find(function(k) { return helmetStock[k] === true; });
      if(first){state.color=first.split("-")[0];state.size=first.split("-")[1];}
      else state.helmet=false;
    }
    render();
  }
  fetch("/products/elf-fb20-thermal-fusion-night-vision-binocular.js", {credentials:"same-origin"})
    .then(function(r){if(!r.ok)throw new Error("Stock unavailable");return r.json();})
    .then(updateProductStock).catch(function(){/* Shopify validates stock on cart submission. */});
  fetch("/products/fast-sf-helmet.js", {credentials:"same-origin"})
    .then(function(r){if(!r.ok)throw new Error("Helmet stock unavailable");return r.json();})
    .then(updateHelmetStock).catch(function(){updateHelmetStock(null);});
  var strike = $(".hero h1 > span");
  function fitStrike() {
    if(!strike)return;
    Array.prototype.forEach.call(strike.children,function(c){c.style.transformOrigin="left";c.style.transform="scaleX("+Math.min(1,strike.clientWidth/c.scrollWidth)+")";});
  }
  fitStrike();
  if(document.fonts)document.fonts.ready.then(fitStrike);
  window.addEventListener("resize",fitStrike);
  render();
})();

/* with/without sliders (same behaviour as the ADV-COTI lander), added 13 Oct */
(function () {
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function init() {
    all("#no-dfb31 [data-comparison]").forEach(function (frame) {
      var input = frame.querySelector("input[type=range]"), before = frame.querySelector("[data-before-layer]");
      if (!input || !before || frame.getAttribute("data-ready") === "1") return;
      frame.setAttribute("data-ready", "1");
      function update(v) {
        v = Math.max(0, Math.min(100, v)); input.value = String(v);
        before.style.clipPath = "inset(0 " + (100 - v) + "% 0 0)";
        all("[data-comparison-handle]", frame).forEach(function (x) { x.style.left = v + "%"; });
        input.setAttribute("aria-valuetext", Math.round(v) + " percent without fusion");
      }
      function pointer(e) { var r = frame.getBoundingClientRect(); update((e.clientX - r.left) / r.width * 100); }
      input.addEventListener("input", function () { update(Number(input.value)); });
      input.addEventListener("pointerdown", function (e) { input.setPointerCapture(e.pointerId); pointer(e); });
      input.addEventListener("pointermove", function (e) { if (input.hasPointerCapture(e.pointerId)) pointer(e); });
      update(50);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
